<div class="language-selector" (clickOutside)="closePopover()">
  <!-- Globe Icon Button -->
  <button
    class="language-selector__toggle"
    [class.language-selector__toggle--active]="showPopover"
    (click)="togglePopover()"
    type="button">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="10"
        cy="10"
        r="8.5"
        stroke="currentColor"
        stroke-width="1.5" />
      <path d="M2 10H18" stroke="currentColor" stroke-width="1.5" />
      <path
        d="M10 2C10 2 14 6 14 10C14 14 10 18 10 18"
        stroke="currentColor"
        stroke-width="1.5" />
      <path
        d="M10 2C10 2 6 6 6 10C6 14 10 18 10 18"
        stroke="currentColor"
        stroke-width="1.5" />
    </svg>
  </button>

  <!-- Language Popover -->
  <div class="language-selector__popover" *ngIf="showPopover">
    <button
      class="language-selector__option"
      [class.language-selector__option--active]="languageActive === 'pt-br'"
      type="button"
      (click)="selectLanguage('pt-br')">
      Português (BR)
    </button>
    <button
      class="language-selector__option"
      [class.language-selector__option--active]="
        languageActive === 'en-us' || languageActive === 'en'
      "
      type="button"
      (click)="selectLanguage('en')">
      English
    </button>
  </div>
</div>
